var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluetooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 46,
    viewBox: "0 0 34 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2332_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8634 11.3264L22.6741 15.1193L18.8656 18.909L18.8634 11.3264ZM18.8634 34.5442L22.6741 30.7521L18.8656 26.9616L18.8634 34.5442ZM14.7945 22.9354L6.55642 14.7152L8.94426 12.3394L15.5068 18.874V3.21432L27.4421 15.0921L19.5616 22.9354L27.4436 30.7807L15.5077 42.6588V26.998L8.94346 33.5335L6.55549 31.1561L14.7945 22.9354ZM17.0016 45.8738C27.0656 45.8738 34 41.1151 34 22.936C34 4.7577 27.0656 0 17.0016 0C6.93812 0 0 4.75849 0 22.936C0 41.1153 6.93746 45.8738 17.0016 45.8738Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2332_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetooth);
export default __webpack_public_path__ + "static/media/Bluetooth.2cae86c38dc09205111aadab3d38948b.svg";
export { ForwardRef as ReactComponent };